// extracted by mini-css-extract-plugin
export var container = "home-layout-module--container--qgatl";
export var heading = "home-layout-module--heading--Ol9tu";
export var imgGrid = "home-layout-module--img-grid--WRy3S";